import SettingsHeadline from './SettingsHeadline';

export default SettingsHeadline;
